import type { Demand } from "./types";
import { links } from "./links";

// Content for the Detroit Divest campaign page. Rich text is Markdown.

export const divestTitleParts = {
  before: "THE ",
  highlight: "DETROIT DIVEST",
  after: " CAMPAIGN.",
};

export const petitionLabel = "Sign our petition";
export const petitionUrl = links.petition;

// Figures are from the divestment resolution. Kept distinct from the $43M in
// demand 3 so the page does not repeat the same number twice.
export const demandsIntro =
  "Between 2024 and 2025, the City of Detroit paid **$299,734,297** to companies profiting from the genocide in Palestine, and **$272,557,747** to vendors under contract with the Department of War. Police officers here have trained with the Israeli military in Occupied Palestine. We have three demands.";

export const demands: Demand[] = [
  {
    number: 1,
    title: "DIVEST DETROIT FROM WAR PROFITEERS",
    body: "We believe Detroit’s funds should be used to improve the lives of Detroiters, not for war. We therefore demand that the City Council divest their finances from companies identified as war profiteers that contribute to human rights violations.",
    faqs: [
      {
        q: "What is divestment?",
        a: "Divestment refers to the cutting ties between an institution or municipality, such as the city government, and companies and other entities who commit human rights violations. We primarily target companies that contribute to the on-going genocide in Palestine, but as an anti-war organization, we believe that all war profiteers should be divested from.",
      },
      {
        q: "What are war profiteers?",
        a: "A war profiteer is a company, person, or other entity that profits from the Military Industrial Complex and human rights violations.",
      },
    ],
  },
  {
    number: 2,
    title: "END CROSS-TRAINING",
    body: "We demand that the Detroit Police Department agrees to never cross-train directly with israeli officials and to end all cross-trainings between DPD and other Metro Detroit Police Departments that have cross-trained, such as Wayne State police. These cross-trainings began after 9/11, because “israel” was considered *the best in counter-terrorism.* They are global leaders in surveillance tactics used against Palestinians, and now against civilians in the U.S. by ICE. These tactics include the discriminatory, racially-biased, and excessively forceful approaches, which we can see in the U.S. with murders like George Floyd’s and even here in Detroit with Sherman Lee Butler’s.",
    faqs: [
      {
        q: "What are cross-trainings?",
        a: "Cross-training refers to “exchange programs” or training programs where United States law enforcement agencies, from the local police to ICE, train with israeli government officials and agencies to learn their tactics.",
      },
    ],
  },
  {
    number: 3,
    title: "END ALL U.S. AID TO israel",
    body: "As of August 2025, the United States has appropriated $4 billion in assistance for israel and has conducted over $12 billion in weapons sales this year alone. While many of these dollars are appropriated at the federal level, roughly $43 million in Detroit taxpayer funds will fund the ongoing genocide on Palestinians in 2025 alone. We believe elected officials should use our tax dollars to improve the quality of life for people in our country – not funding the destruction and annihilation of people across the globe. Therefore, we demand that the United States government end all aid to so-called “israel”.",
    faqs: [],
  },
];
